import { useTranslation } from 'react-i18next';

import { EMPTY_VALUE_LABEL } from 'constants/commonLabels';
import { CommercialNetwork, DistributionCenter } from 'interfaces';

import styles from './DistributionCenterData.module.css';

type DistributionCenterDataProps = {
   distributionCenter: DistributionCenter;
   commercialNetwork: CommercialNetwork;
};

const DistributionCenterData = ({
   distributionCenter,
   commercialNetwork,
}: DistributionCenterDataProps) => {
   const { t } = useTranslation();

   return (
      <div className={styles.container}>
         <div className={styles.column}>
            <div className={styles.row}>
               <p className={styles.sectionLabel}>{t('distribution_center.network')}</p>
               <p className={styles.sectionText}>{commercialNetwork.name}</p>
            </div>
            <div className={styles.row}>
               <p>{t('distribution_center.street')}</p>
               <p>{distributionCenter.address.street}</p>
            </div>
            <div className={styles.multiRow}>
               <div className={styles.row}>
                  <p className={styles.sectionLabel}>{t('distribution_center.zip')}</p>
                  <p>{distributionCenter.address.zipCode}</p>
               </div>
               <div className={styles.row}>
                  <p className={styles.sectionLabel}>{t('distribution_center.city')}</p>
                  <p>{distributionCenter.address.city}</p>
               </div>
            </div>
         </div>
         <div className={styles.column}>
            <div className={styles.row}>
               <p className={styles.sectionLabel}>{t('sent_password_reset.phone')}</p>
               <p>{distributionCenter.phoneNumber || EMPTY_VALUE_LABEL}</p>
            </div>
            <div className={styles.row}>
               <p className={styles.sectionLabel}>{t('login.email')}</p>
               <p>{distributionCenter.contactEmail || EMPTY_VALUE_LABEL}</p>
            </div>
         </div>
      </div>
   );
};

export default DistributionCenterData;
